import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'

import {
  DemandPlanningRBAC,
  SKUDetailsReviewRBAC,
  ConfigBankRBAC,
  CampaignDashboardRBAC,
  CampaignHistoryRBAC,
  FestiveDashboardRBAC,
  FestiveHistoryRBAC,
} from './rbac'

const DemandPlanning = lazy(() => import('../pages/DemandPlanning/Dashboard'))
const SKUDetailsReview = lazy(() => import('../pages/DemandPlanning/SKUDetailsReview'))
const ConfigBank = lazy(() => import('../pages/ConfigBank'))
const CampaignDashboard = lazy(() => import('../pages/Campaign/CampaignDashboard'))
const CampaignHistory = lazy(() => import('../pages/Campaign/CampaignHistory'))

export const DemandPlanningRouter: RouterFeatureInterface<
  'DemandPlanning',
  '/dashboard/demand-planning'
> = {
  name: 'DemandPlanning',
  Component: DemandPlanning,
  path: '/dashboard/demand-planning',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: DemandPlanningRBAC.pageID,
}

export const SKUDetailsRouter: RouterFeatureInterface<
  'SKUDetailsRouter',
  '/dashboard/demand-planning/sku-details'
> = {
  name: 'SKUDetailsRouter',
  Component: SKUDetailsReview,
  path: '/dashboard/demand-planning/sku-details',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SKUDetailsReviewRBAC.pageID,
}

export const SKUReviewRouter: RouterFeatureInterface<
  'SKUReviewRouter',
  '/dashboard/demand-planning/sku-review'
> = {
  name: 'SKUReviewRouter',
  Component: SKUDetailsReview,
  path: '/dashboard/demand-planning/sku-review',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SKUDetailsReviewRBAC.pageID,
}

export const ConfigBankRouter: RouterFeatureInterface<
  'ConfigBankRouter',
  '/dashboard/scms/config-bank'
> = {
  name: 'ConfigBankRouter',
  Component: ConfigBank,
  path: '/dashboard/scms/config-bank',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: ConfigBankRBAC.pageID,
}

export const CampaignDashboardRouter: RouterFeatureInterface<
  'CampaignRouter',
  '/dashboard/scms/campaign'
> = {
  name: 'CampaignRouter',
  Component: CampaignDashboard,
  path: '/dashboard/scms/campaign',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: CampaignDashboardRBAC.pageID,
}

export const CampaignHistoryRouter: RouterFeatureInterface<
  'CampaignRouter',
  '/dashboard/scms/campaign-history'
> = {
  name: 'CampaignRouter',
  Component: CampaignHistory,
  path: '/dashboard/scms/campaign-history',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: CampaignHistoryRBAC.pageID,
}

export const FestiveDashboardRouter: RouterFeatureInterface<
  'FestiveRouter',
  '/dashboard/scms/Festive'
> = {
  name: 'FestiveRouter',
  Component: CampaignDashboard,
  path: '/dashboard/scms/Festive',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: FestiveDashboardRBAC.pageID,
}

export const FestiveHistoryRouter: RouterFeatureInterface<
  'FestiveRouter',
  '/dashboard/scms/Festive-history'
> = {
  name: 'FestiveRouter',
  Component: CampaignHistory,
  path: '/dashboard/scms/Festive-history',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: FestiveHistoryRBAC.pageID,
}

const SCMSRouter = [
  DemandPlanningRouter,
  SKUDetailsRouter,
  SKUReviewRouter,
  ConfigBankRouter,
  CampaignDashboardRouter,
  CampaignHistoryRouter,
  FestiveDashboardRouter,
  FestiveHistoryRouter,
]

export const SCMSRouterDetail = generateRouterDetail(SCMSRouter)
export default SCMSRouter
